import { useIsDesktop } from './useIsDesktop';

/**
 * The navigation's own breakpoint, which is not useBreakpoint's 640px: below this width
 * Navigation.module.css hides `.desktopActions` and shows `.mobileControls`. Anything deciding
 * which of the two it belongs to has to agree on this number, or it renders into a hidden
 * container — or, worse, into both.
 */
const NAV_DESKTOP_BREAKPOINT = 1300;
export const useIsNavDesktop = () => {
  return useIsDesktop(NAV_DESKTOP_BREAKPOINT);
};